import { useState, useEffect } from 'react';
import { Modals } from '../../Molecules/Modals';
import { ErrorModal } from '../../Molecules/ErrorModal';
import { Loader } from '../../Molecules/Loader';
import Axios from 'axios';
import { YouInvest } from 'src/Api';

export default function AddInvestmentModal({quote, watchlists, reload, setReload, isGuest, isScreener}) {
    const [id, setId] = useState(watchlists.length ? watchlists[0].id : null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [errorModalIsOpen, setErrorModalIsOpen] = useState(false);
    const [displayError, setDisplayError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [createWatchlist, setCreateWatchlist] = useState(watchlists.length ? false : true);
    const [watchlistName, setWatchlistName] = useState(`Watchlist ${watchlists.length + 1}`);

    const refreshHooks = () => {
        setId(watchlists.length ? watchlists[0].id : null);
        setModalIsOpen(false);
        setQuantity(1);
        setCreateWatchlist(watchlists.length ? false : true);
        setWatchlistName(`Watchlist ${watchlists.length + 1}`);
        setDisplayError(null);
    }

    useEffect(() => {refreshHooks()}, [watchlists]);

    const openModal = (event) => {
        event.preventDefault();

        if (isGuest) {
            setErrorModalIsOpen(true);
        } else {
            setModalIsOpen(true);
        }
    }
    
    const closeModal = (event) => {
        event.preventDefault();

        if (isGuest) {
            setErrorModalIsOpen(false);
        } else {
            refreshHooks();
        }
    }
    
    const displayOptions = () => {
        return watchlists.map(watchlist => {
            return <option key={watchlist.id} value={watchlist.id}>{watchlist.name}</option>
        });
    }

    const changeHandler = (event) => {
        if (event.target.value === 'createWatchlist') {
            setCreateWatchlist(true);
        } else {
            const watchlist = watchlists.find(item => item.id === event.target.value);

            setCreateWatchlist(false);
            setId(watchlist.id);
        }
    }

    const quantityChangeHandler = (event) => {
        if (!isNaN(event.target.value)) {
            setQuantity(event.target.value);
        }
    }

    const saveItem = (event) => {
        event.preventDefault();

        if (!id || !id.length) {
            setDisplayError('Watchlist ID is required');
            return;
        } else if (typeof quote.marketCode !== 'string') {
            setDisplayError(`Market Code is required.`);
            return;
        } else if (quantity == '') {
            setDisplayError(`Quantity is required.`);
            return;
        } else if (Number(quantity) < 1) {
            setDisplayError(`Quantity should be no less than 1.`);
            return;
        } else if ((quote.__typename === 'Fund' && !quote.lastPrice) || (quote.__typename !== 'Fund' && !quote.askPrice)) {
            setDisplayError(`Investment has no price.`);
            return;
        }

        setLoading(true);
        Axios({
            method: 'POST',
            url: `/api/v2/watchlists/index/insert-item`,
            data: {
                watchlistId: id,
                marketCode: quote.marketCode,
                quantity: Number(quantity),
                price: quote.__typename === 'Fund' ? quote.lastPrice : quote.askPrice
            }
        }).then(response => {
            setLoading(false);
            closeModal(event);
        }).catch(error => {
            setLoading(false);
            setDisplayError(error.response.data.message);
        });
    }

    const addWatchlist = (event) => {
        event.preventDefault();
        if (!watchlistName.length || watchlistName.length < 2) {
            setDisplayError('Watchlist name must be at least 2 characters long.');
            return;
        } else if (typeof watchlistName !== 'string') {
            setDisplayError(`Watchlist name must be a string.`);
            return;
        } else {
            if (watchlists) {
                for (let w in watchlists) {
                    if (watchlists[w].name == watchlistName) {
                        setDisplayError('Please enter a unique watchlist name');
                        return;
                    }
                }
            }
            
            setLoading(true);
            Axios({
                method: 'POST',
                url: `/api/v2/watchlists/index/create-watchlist`,
                data: {
                    name: watchlistName
                }
            }).then(response => {
                setLoading(false);
                setReload(!reload);
                closeModal(event);
            }).catch(error => {
                setLoading(false);
                closeModal(event);
            });
        }
    }

    return <>
        <span onClick={openModal} className="margin-bottom-10 max-characters-none">
            <a className={`c-btn waves-effect waves-light button-outline button button--outline-darkblue c-btn-small no-arrow modal-trigger ${isScreener ? "screener-watchlists-button" : ""}`} href="" aria-label="Add to watchlist" title="Add to watchlist">
                {isScreener ? <i className="fas fa-solid fa-eye" aria-hidden="true"></i> : <>
                    <i className="fas fa-plus-circle padding-right-5"></i>Add to watchlist
                </>}
            </a>
        </span>


        <Modals isOpen={modalIsOpen} close={closeModal} label="Add investment to watchlist" className="modal modal-fixed-footer grey-0-bg open" id="add-investment-modal">
            <div className="modal-content" data-role="dialog" aria-modal="true" aria-label="modal" style={{padding: "20px"}}>
                <h2 className="ajb-col-12" id="add-investment-modal">Add investment to watchlist</h2>
                <div className="ajb-grid-row margin-bottom-30">
                    <div className="ajb-col-12 ajb-col-8-breakpoint padding-20 padding-10-sm padding-top-30-sm white-bg border-radius-10 z-depth-5">
                        {displayError ? <p style={{color: 'red'}}>{displayError}</p> : null}
                        <div className="ajb-grid-row">
                            <div className="ajb-col-6 ajb-col-8-breakpoint">
                                <label className="black-text" style={{marginBottom: "5px"}}>Select watchlist</label>
                                <select onChange={changeHandler} value={createWatchlist ? "createWatchlist" : id} id="add-to-watchlist-selectmenu" className="add-to-watchlist-selectmenu browser-default margin-0">
                                    {displayOptions()}
                                    {watchlists.length < 10 ? <option value="createWatchlist">Create new watchlist</option> : null}
                                </select>
                            </div>
                        </div>

                        {createWatchlist ? <div className="ajb-grid-row newWatchlistName margin-bottom-20 margin-top-40">
                            <div className="ajb-col-6 ajb-col-8-breakpoint">
                                <label className="black-text active" htmlFor="watchlistName">Watchlist name</label>
                                <input onChange={(e) => setWatchlistName(e.target.value)} value={watchlistName} placeholder="" id="watchlistName" name="watchlistName" type="text" className="validate" />
                            </div>
                        </div> : null}

                        {!createWatchlist ? <table className="data-table data-table--medium">
                            <thead>
                                <tr>
                                    <th><span className="h6 font-weight-bold">Investment</span></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className={`watchlist-add-btn-form-item-row`}>
                                    <td>{quote.name}</td>
                                    <td>
                                        <div className="margin-bottom-0">
                                            <label className="black-text active" htmlFor="quantity">Quantity</label>
                                            <input onChange={quantityChangeHandler} value={quantity} id="quantity" name="quantity" className="validate" />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table> : null}
                    </div>
                </div>
            </div>
            <div className="modal-footer padding-10" style={{height: "auto", background: "white", width: "100%", display: "flex", justifyContent: "space-between"}}>
                <a onClick={closeModal} href="" className="modal-close float-left margin-right-10 margin-bottom-10-sm c-btn button-default waves-effect waves-light button button--darkblue">Cancel</a>
                {createWatchlist ? <a onClick={addWatchlist} href="" className="modal-close c-btn button-default waves-effect waves-light button button--red newWatchlistName"><i className="fa fa-plus-circle margin-right-5"></i>Create a watchlist</a> : <a onClick={saveItem} href="" className="modal-close c-btn button-default waves-effect waves-light button button--red watchlist--btn">Save</a>}
            </div>
        </Modals>

        <ErrorModal isOpen={errorModalIsOpen} close={closeModal} secondButton={<a href={`/login?RedirectBack=${encodeURIComponent(`${window.location.pathname}`)}`} className="modal-close c-btn button-default waves-effect waves-light button button--red">Log in</a>}>Please log in to add an investment to your watchlist</ErrorModal>

        {loading ? <Loader /> : null}
    </>
}